function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Premium_1_"
}, /*#__PURE__*/React.createElement("title", null, "VF_premium_rgb"), /*#__PURE__*/React.createElement("g", {
  id: "Premium"
}, /*#__PURE__*/React.createElement("path", {
  d: "M133.3 140.1l-42.4-34.4 17.9-22.1 22.4 18.1 47.5-47.9 20.2 20.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M248 101C248 31.4 200.4 0 141.7 0S35.4 31.4 35.4 101c0 41.3 16.8 69.2 42.7 85v97.5l63.6-35.5 63.6 35.5V186c26-15.9 42.7-43.7 42.7-85zm-71.2 134l-35.1-19.6-35.1 19.6v-37.2c11.5 2.9 23.3 4.3 35.1 4.2 11.8.1 23.6-1.3 35.1-4.2V235zm21.5-79c-13.3 11.5-32.9 17.5-56.6 17.5-23.7 0-43.3-6.1-56.6-17.5-14.1-12.1-21.2-30.6-21.2-55S71 58.1 85.1 46c13.3-11.5 32.9-17.5 56.6-17.5 23.7 0 43.3 6.1 56.6 17.5 14.1 12.1 21.2 30.6 21.2 55s-7.1 42.9-21.2 55z"
})))));